import { DIRECTIONS } from '@btime/constants'
import { State, appendValueOnIndex, removeValueWithIndex } from '@btime/state-monad'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { useScreenState } from '../_load/ScreenLoader'

const MUTATION = gql`
  mutation UpsertScreen($input: ScreenInput) {
    upsertScreen(input: $input) {
      id
      name
    }
  }
`

const moveColumn = (screen, column, index, direction) => {
  const newIndex = index + (direction === DIRECTIONS.UP ? 0 : +1)
  const removeIndex = column.index + (newIndex < column.index ? +1 : 0)

  return {
    ...screen,
    data: {
      ...screen.data,
      columns: State.of(screen.data?.columns) //
        .map(appendValueOnIndex(newIndex, column))
        .map(removeValueWithIndex(removeIndex))
        .fold()
    }
  }
}

const cleanRequest = screen => ({
  id: screen.id,
  data: JSON.stringify(screen.data)
})

export const useMoveColumnAndSaveScreen = () => {
  const { screen, setScreen } = useScreenState()

  const [request, state] = useMutation(MUTATION, { client: generalClient })

  const handleRequest = (column, index, direction) => {
    const formattedScreen = moveColumn(screen, column, index, direction)
    setScreen(formattedScreen)
    const input = cleanRequest(formattedScreen)
    return request({ variables: { input } }).then(resp => {})
  }

  return [handleRequest, state]
}
